import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'bijeenkomst',
    templateUrl: 'bijeenkomst.html'
})
export class Bijeenkomst implements OnInit {
    constructor() { }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/pages/bijeenkomst/bijeenkomst.ts